<template>
  <v-container fluid fill-height class="grey lighten-3 pl-2 pr-2 pt-2" style="overflow: auto">
    <v-layout row wrap>
      <v-flex xs12>
        <div class="mt-2 mb-2 ob-section-title-and-tabs">
          <h1 class="headline ob-section-title pr-4 primary--text d-flex mb-2">
            <v-avatar class="ob-no-grow-or-shrink mr-2" :class="{ 'ob-rotate': loading }" size="36">
              <img src="/img/tud_group_round_transparent.png" alt="TUD Group company logo">
            </v-avatar>
            {{ translateUI(label, lang) }}
            <v-spacer></v-spacer>
          </h1>
        </div>
          <v-stepper v-model="wiz" vertical>
            <v-stepper-step :complete="wiz > 1" step="1" editable>
              Selectare perioade de referinta
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-layout row wrap>
                <v-flex xs3 v-for="p in perioade" :key="p">
                  <v-checkbox
                    v-model="selectedPerioade"
                    :label="p"
                    :value="p">
                  </v-checkbox>
                </v-flex>
              </v-layout>
              <v-btn color="primary" @click="wiz = 2">
                Pasul 2
                <v-icon right>mdi-arrow-down-bold</v-icon>
              </v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="wiz > 2" step="2" editable>
              Selectare APL-uri sau grupuri de APL-uri
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-card flat color="grey lighten-4" class="mb-5" max-height="50vh">
                <v-card-text class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="d-flex interactive-wizard">
                      <v-subheader class="d-inline-flex">Disponibile</v-subheader>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="aplSearch"
                        prepend-inner-icon="mdi-magnify"
                        label="Cauta"
                        single-line
                        hide-details
                        clearable
                        solo flat
                        class="pt-0">
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-subheader class="d-inline-flex" style="justify-content: flex-end">Selectate</v-subheader>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard">
                      <v-list subheader dense two-line style="max-height: calc(50vh - 132px); height: 100%; overflow: auto; width: 100%">
                        <template v-for="judet in pagedCifuri">
                          <v-divider :key="judet.cif_op + 1"></v-divider>
                          <v-subheader :key="judet.cif_op + 2">{{ judet.judet }}</v-subheader>
                          <v-divider :key="judet.cif_op + 3"></v-divider>
                          <template v-for="cif in judet.children">
                            <v-list-tile :key="'available' + cif.cif_op" :color="highlightCif(cif)">
                              <v-list-tile-avatar>
                                {{ cif.tip_apl.substring(0, 1)}}
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  {{ cif.denumire_apl }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  {{ cif.cif_op }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-btn icon @click="toggleCifSelection(cif, 1)" :disabled="cif.disabled">
                                  <v-icon color="green">mdi-arrow-right-bold</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>
                        </template>
                      </v-list>
                      <div class="d-flex" style="align-items: center">
                        <v-btn icon :disabled="cifuriPage === 0" @click="cifuriPage--">
                          <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-select
                          v-model="cifuriPage"
                          :items="cifuriPages"
                          dense
                          label="Alegeti pagina">
                        </v-select>
                        <v-btn icon :disabled="cifuriPage === cifuriPages.length - 1" @click="cifuriPage++">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard">
                      <v-list dense two-line style="max-height: calc(50vh - 132px); height: 100%; overflow: auto; width: 100%">
                        <v-list-tile v-for="cif in selectedCifuri" :key="'selected' + cif.cif_op">
                          <v-list-tile-action>
                            <v-btn icon @click="toggleCifSelection(cif, -1)">
                              <v-icon color="red">mdi-arrow-left-bold</v-icon>
                            </v-btn>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ cif.denumire_apl }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{ cif.cif_op }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-btn color="primary" @click="wiz = 3">
                Pasul 3
                <v-icon right>mdi-arrow-down-bold</v-icon>
              </v-btn>
              <v-btn @click="wiz = 1">Inapoi</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="wiz > 3" step="3" editable>
              Selectare rapoarte
            </v-stepper-step>
            <v-stepper-content step="3">
              <v-card flat color="grey lighten-4" class="mb-5" max-height="50vh">
                <v-card-text class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 class="d-flex interactive-wizard">
                      <v-subheader class="d-inline-flex">Disponibile</v-subheader>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="rapoarteSearch"
                        prepend-inner-icon="mdi-magnify"
                        label="Cauta"
                        single-line
                        hide-details
                        clearable
                        solo flat
                        class="pt-0">
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-subheader class="d-inline-flex" style="justify-content: flex-end">Selectate</v-subheader>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard pr-1">
                      <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                        <v-list-tile v-for="raport in filteredRapoarte" :key="'selected' + raport._id">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ translateUI(raport.denumire, lang) }} ({{ raport.denumire }})
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{ translateUI(raport.detalii, lang) }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-btn icon @click="toggleRaportSelection(raport, 1)" :disabled="raport.disabled">
                              <v-icon color="green">mdi-arrow-right-bold</v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex xs6 class="interactive-wizard pl-1">
                      <v-list subheader dense two-line style="max-height: calc(50vh - 145px); height: 100%; overflow: auto; width: 100%">
                        <v-list-tile v-for="raport in selectedRapoarte" :key="'selected' + raport._id">
                          <v-list-tile-action>
                            <v-btn icon @click="toggleRaportSelection(raport, -1)">
                              <v-icon color="red">mdi-arrow-left-bold</v-icon>
                            </v-btn>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ translateUI(raport.denumire, lang) }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{ translateUI(raport.detalii, lang) }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-menu bottom left :max-height="'50vh'" :close-on-content-click="false">
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                  <v-icon>mdi-cogs</v-icon>
                                </v-btn>
                              </template>

                              <v-list dense subheader>
                                <v-subheader>Perioada</v-subheader>
                                <v-list-tile @click="toggleCustomization(raport, 'perioade', p)" v-for="p in perioade" :key="p">
                                  <v-list-tile-action>
                                    <v-checkbox v-model="raport.perioade" :value="p" @click.prevent>
                                    </v-checkbox>
                                  </v-list-tile-action>
                                  <v-list-tile-title>
                                    {{ p }}
                                  </v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-switch v-model="rename" label="Redenumire cif_op in denumire_apl in denumirea arhivei (fisierele xlsx raman nemodificate)?"></v-switch>
              <v-btn color="primary" @click="download" :disabled="!selectedCifuri.length || !selectedRapoarte.length" :loading="loading">
                Download
                <v-icon right>mdi-progress-download</v-icon>
              </v-btn>
              <v-btn @click="wiz = 2">Inapoi</v-btn>
            </v-stepper-content>

          </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import translate from '@/mixins/Translate';
import streamSaver from 'streamsaver';

export default {
  name: 'rapoarte-download',
  mixins: [translate],
  data: () => ({
    type: 'download',
    loading: false,
    rename: true,
    label: 'SectiuneDownload_Titlu',
    wiz: 1,
    perioade: [],
    selectedPerioade: [],
    cifuriGrupate: [],
    selectedCifuri: [],
    rapoarte: [],
    selectedRapoarte: [],
    cifuriPage: 0,
    cifuriPerPage: 2,
    aplSearch: null,
    rapoarteSearch: null
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    user () {
      return this.$store.getters['user']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    languages () {
      return this.$store.getters['dictionar/languages']
    },
    filteredCifuri () {
      const validCif = cif => cif.denumire_apl.toLowerCase().includes(this.aplSearch.trim().toLowerCase()) || cif.cif_op.trim().toLowerCase().includes(this.aplSearch.trim().toLowerCase())

      if (![null, undefined, ''].includes(typeof this.aplSearch === 'string' ? this.aplSearch.trim() : this.aplSearch)) {
        return this.cifuriGrupate.filter(judet => validCif(judet) || judet.children.some(cif => validCif(cif)))
      } else {
        return this.cifuriGrupate
      }
    },
    cifuriPages () {
      const labels = []
      for (let i = 0; i <= Math.ceil(this.filteredCifuri.length / this.cifuriPerPage); i++) {
        labels.push({
          value: i,
          text: this.filteredCifuri.slice(i * this.cifuriPerPage, (i + 1) * this.cifuriPerPage).reduce((acc, item) => {
            acc.push(item.judet)
            return acc
          }, []).join(', ')
        })
      }

      return labels.filter(label => label.text.length)
    },
    pagedCifuri () {
      return this.filteredCifuri.slice(this.cifuriPerPage * this.cifuriPage, this.cifuriPerPage * (this.cifuriPage + 1))
    },
    filteredRapoarte () {
      const validItem = item =>
        item.denumire.toLowerCase().includes(this.rapoarteSearch.trim().toLowerCase()) ||
        item.detalii.toLowerCase().includes(this.rapoarteSearch.trim().toLowerCase()) ||
        this.translateUI(item.denumire.toLowerCase(), this.lang).includes(this.rapoarteSearch.trim().toLowerCase()) ||
        this.translateUI(item.detalii.toLowerCase(), this.lang).includes(this.rapoarteSearch.trim().toLowerCase())

      if (![null, undefined, ''].includes(typeof this.rapoarteSearch === 'string' ? this.rapoarteSearch.trim() : this.rapoarteSearch)) {
        return this.rapoarte.filter(raport => validItem(raport))
      } else {
        return this.rapoarte
      }
    },

    formatedCifuri () {
      // K!prop_tr_an_cif
      const getType = type => {
        switch (type.toLowerCase()) {
          case 'apl-urile': {
            return 'all'
          }
          case 'judetele': {
            return 'Judet'
          }
          case 'municipiile': {
            return 'Municipiu'
          }
          case 'orasele': {
            return 'Oras'
          }
          case 'comunele': {
            return 'Comuna'
          }
        }
      }
      const cifuri = []
      this.selectedCifuri.forEach(cif => {
        if (cif.cif_op.startsWith('toate')) {
          if (cif.cif_op.includes('din')) {
            const parts = cif.cif_op.split(' ')
            const parentCif = parts.pop()
            const aplType = getType(parts[1])
            const judet = this.cifuriGrupate.find(j => j.cif_op === parentCif)

            if (aplType === 'all') {
              // cifuri.push(judet.cif_op + judet.denumire_apl)
              cifuri.push(...judet.children.filter(c => c.tip_apl !== 'R').map(c => ({ cif: c.cif_op, apl: c.denumire_apl, judet: c.judet })))
            } else {
              cifuri.push(...judet.children.filter(c => c.tip_apl !== 'R' && c.tip_apl === aplType).map(c => ({ cif: c.cif_op, apl: c.denumire_apl, judet: c.judet })))
            }
          } else {
            const parts = cif.cif_op.split(' ')
            const aplType = getType(parts[1])

            if (aplType === 'all') {
              this.cifuriGrupate.forEach(judet => {
                // cifuri.push(judet.cif_op)
                judet.children.forEach(c => {
                  if (c.tip_apl !== 'R') {
                    cifuri.push({ cif: c.cif_op, apl: c.denumire_apl, judet: c.judet })
                  }
                })
              })
            } else if (aplType === 'Judet') {
              this.cifuriGrupate.forEach(judet => {
                if (judet.tip_apl === 'Judet') cifuri.push({ cif: judet.cif_op, apl: judet.denumire_apl, judet: judet.judet })
              })
            } else {
              this.cifuriGrupate.forEach(judet => {
                judet.children.forEach(c => {
                  if (c.tip_apl === aplType) {
                    cifuri.push({ cif: c.cif_op, apl: c.denumire_apl, judet: c.judet })
                  }
                })
              })
            }
          }
        } else {
          cifuri.push({ cif: cif.cif_op, apl: cif.denumire_apl, judet: cif.judet })
        }
      })

      return cifuri
    }
  },
  methods: {
    toggleCifSelection (cif, mode) {
      if (mode === 1) {
        this.selectedCifuri.push({ ...cif })
        const judet = this.cifuriGrupate.find(c => c.judet === cif.judet)
        const apl = judet.children.find(c => c.cif_op === cif.cif_op)
        apl.disabled = true
      } else {
        const selectedIndex = this.selectedCifuri.findIndex(c => c.cif_op === cif.cif_op)
        this.selectedCifuri.splice(selectedIndex, 1)
        const judet = this.cifuriGrupate.find(c => c.judet === cif.judet)
        const apl = judet.children.find(c => c.cif_op === cif.cif_op)
        apl.disabled = false
      }
    },
    toggleRaportSelection (raport, mode) {
      if (mode === 1) {
        this.selectedRapoarte.push({ ...raport, perioade: [ ...this.selectedPerioade ] })
        raport.disabled = true
      } else {
        const selectedIndex = this.selectedRapoarte.findIndex(r => r._id === raport._id)
        this.selectedRapoarte.splice(selectedIndex, 1)
        const item = this.rapoarte.find(r => r._id === raport._id)
        item.disabled = false
      }
    },
    highlightCif (cif) {
      if ([null, undefined, ''].includes(typeof this.aplSearch === 'string' ? this.aplSearch.trim() : this.aplSearch)) return 'undefined'
      else if (cif.denumire_apl.toLowerCase().includes(this.aplSearch.trim().toLowerCase()) || cif.cif_op.trim().toLowerCase().includes(this.aplSearch.trim().toLowerCase())) {
        return 'accent'
      }
      return 'undefined'
    },

    toggleCustomization (item, prop, value) {
      switch (prop) {
        case 'perioade': {
          const index = item.perioade.findIndex(p => p === value)
          if (index === -1) {
            item.perioade.push(value)
          } else {
            item.perioade.splice(index, 1)
          }
          break
        }
      }
    },

    async getCifuri () {
      const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token
      })

      try {
        const perioadeResponse = await fetch(`${this.host}/cifuriperioade?$sort[label]=-1&$paginate&$select[]=label`, {
          method: 'get',
          headers
        })
        const perioade = await perioadeResponse.json()
        this.perioade = perioade.map(p => p.label)

        const cifuriHeadersResponse = await fetch(`${this.host}/cifuriheaders?$paginate=false&$select=value&$select=meaning&perioada=${perioade[0]._id}&$sort[value]=1`, {
          method: 'get',
          headers
        })
        const cifuriHeaders = await cifuriHeadersResponse.json()

        this.cifuriProps = cifuriHeaders.filter(h => !['_id', 'createdAt', 'updatedAt', 'computed', 'verificare', 'prioritate'].includes(h.value))

        const cifuriResponse = await fetch(`${this.host}/cifuri?perioada=${perioade[0]._id}&$paginate&$select=denumire_apl&$select=tip_apl&$select=judet&$select=cif_op&$sort[denumire_apl]=1`, {
          method: 'get',
          headers
        })
        const cifuri = await cifuriResponse.json()
        cifuri.sort((a, b) => {
          if (a.tip_apl === 'Judet' && b.tip_apl !== 'Judet') return -1
          if (a.tip_apl !== 'Judet' && b.tip_apl === 'Judet') return 1
          return 0
        })
        this.cifuri = cifuri.map(c => {
          if (c.tip_apl === 'Comuna') {
            c.denumire_apl = 'Comuna ' + c.denumire_apl
          }

          return c
        }).slice(0, 100)

        const grouped = [{
          cif_op: '0',
          denumire_apl: 'SELECTIE RAPIDA',
          judet: 'SELECTIE RAPIDA',
          tip_apl: 'R',
          municipii: [{
            cif_op: 'toate apl-urile',
            denumire_apl: 'Toate APL-urile',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate judetele',
            denumire_apl: 'Toate Judetele',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate municipiile',
            denumire_apl: 'Toate municipiile',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate orasele',
            denumire_apl: 'Toate orasele',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }, {
            cif_op: 'toate comunele',
            denumire_apl: 'Toate comunele',
            judet: 'SELECTIE RAPIDA',
            tip_apl: 'R',
            disabled: false
          }],
          orase: [],
          comune: []
        }]

        cifuri.forEach(cif => {
          switch (cif.tip_apl) {
            case 'Judet': {
              grouped.push({
                ...cif,
                municipii: [{
                  cif_op: 'toate apl-urile din ' + cif.cif_op,
                  denumire_apl: 'Toate apl-urile din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                }, {
                  cif_op: 'toate municipiile din ' + cif.cif_op,
                  denumire_apl: 'Toate municipiile din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                }, {
                  cif_op: 'toate orasele din ' + cif.cif_op,
                  denumire_apl: 'Toate orasele din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                }, {
                  cif_op: 'toate comunele din ' + cif.cif_op,
                  denumire_apl: 'Toate comunele din ' + cif.denumire_apl,
                  judet: cif.judet,
                  tip_apl: 'R',
                  disabled: false
                },
                {
                  ...cif,
                  disabled: false
                }],
                orase: [],
                comune: []
              })
              break
            }
            case 'Municipiu': {
              if (cif.denumire_apl === 'Municipiul Bucuresti') {
                grouped.push({
                  ...cif,
                  municipii: [{
                    ...cif,
                    disabled: false
                  }],
                  orase: [],
                  comune: []
                })
              } else {
                const parent = grouped.find(j => j.judet === cif.judet)
                parent.municipii.push({ ...cif, disabled: false })
              }
              break
            }
            case 'Oras': {
              const parent = grouped.find(j => j.judet === cif.judet)
              parent.orase.push({ ...cif, disabled: false })
              break
            }
            case 'Comuna': {
              const parent = grouped.find(j => j.judet === cif.judet)
              parent.comune.push({ ...cif, disabled: false })
              break
            }
          }
        })

        grouped.forEach(judet => {
          judet.children = judet.municipii.concat(judet.orase).concat(judet.comune)
          delete judet.municipii
          delete judet.orase
          delete judet.comune
        })

        this.cifuriGrupate = grouped
      } catch (err) {
        console.log(err)
      }
    },

    async getRapoarte () {
      const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.token
      })

      try {
        const rapoarteResponse = await fetch(`${this.host}/rapoarte?$paginate=false&tab=rapoarte&$select=denumire&$select=detalii`, {
          method: 'get',
          headers
        })
        const rapoarte = await rapoarteResponse.json()
        this.rapoarte = rapoarte
      } catch (err) {
        console.log(err)
      }
    },

    download () {
      const rapoarte = this.selectedRapoarte.map(r => ({ id: r._id, perioade: r.perioade, denumire: r.denumire }))
      const cifuri = [...this.formatedCifuri]

      // this.$store.commit(`${this.type}/setLoading`, true)
      this.loading = true
      // const fileStream = createWriteStream(report.zip)
      if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
        streamSaver.mitm = `${this.host}/mitm.html`
      }
      const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_${cifuri.length}_apluri_${rapoarte.length}_rapoarte.zip`)
      fetch(`${this.host}/smb-raport-bulk`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ rapoarte, cifuri, lang: this.lang, rename: this.rename })
      })
        .then(res => {
          // this.$store.commit(`${this.type}/setLoading`, false)
          this.loading = false

          if (!res.ok) {
            const err = res.json().then(mes => {
              alert(mes.error)
            })
            console.log(err)
          } else {
            // more optimized
            if (res.body.pipeTo) {
              return res.body.pipeTo(fileStream).then(() => console.log('done writing'))
            }

            const writer = fileStream.getWriter()
            const reader = res.body.getReader()
            const pump = () => reader.read().then(({ value, done }) => {
              if (done) {
                // close the stream so we stop writing
                writer.close()
                // this.$store.commit(`${this.type}/setLoading`, false)
                this.loading = false
              } else {
                // Write one chunk, then get the next one
                writer.write(value).then(pump)
              }
            })

            // Start the reader
            pump().then(() => {
              // this.$store.commit(`${this.type}/setLoading`, false)
              this.loading = false
              console.log('Closed the stream, Done writing')
            })
          }
        })
        .catch(err => {
          // this.error = true
          // this.$store.commit(`${this.type}/setLoading`, false)
          this.loading = false
          console.log('whoopsie', err)
        })
    },

    dummy () {}
  },
  async created () {
    await this.getCifuri()
    await this.getRapoarte()
  }
}
</script>

<style>

</style>
